import React, { useState } from 'react';

const ContactSection = () => {
  const [showQR, setShowQR] = useState(false);
  const [copied, setCopied] = useState(false);

  const officeHours = [
    { day: 'Monday', hours: '9:00 AM – 8:00 PM' },
    { day: 'Tuesday', hours: '9:00 AM – 8:00 PM' },
    { day: 'Wednesday', hours: '9:00 AM – 8:00 PM' },
    { day: 'Thursday', hours: '9:00 AM – 8:00 PM' },
    { day: 'Friday', hours: '9:00 AM – 8:00 PM' },
    { day: 'Saturday', hours: '9:00 AM – 8:00 PM' },
    { day: 'Sunday', hours: 'Closed' }
  ];

  const wechatUsername = 'wxid_chf1ew488kf612D';
  const email = 'jennywei.me@gmail.com';
  const phone = '(909) 244-7977';

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="container">
        <h2 className="section-title">Contact Us</h2>
        <div className="contact-two-column">
          <div className="contact-left-column">
            <h3 className="contact-column-title">Office Hours</h3>
            <ul className="office-hours-list">
              {officeHours.map((item) => (
                <li key={item.day} className="office-hours-item">
                  <span className="office-day">{item.day}</span>
                  <span className="office-hours">{item.hours}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="contact-right-column">
            <h3 className="contact-column-title">Get in Touch</h3>
            <div className="contact-info-list">
              <div className="contact-info-item">
                <i className="fab fa-weixin contact-icon"></i>
                <div className="contact-info-content">
                  <span className="contact-label">WeChat</span>
                  <span 
                    className="contact-value contact-value-clickable"
                    onClick={() => copyToClipboard(wechatUsername)}
                    title="Click to copy"
                  >
                    {wechatUsername}
                    {copied && <span className="copied-indicator"> ✓ Copied!</span>}
                  </span>
                  <button
                    type="button"
                    className="qr-trigger-btn"
                    onClick={() => setShowQR(true)}
                  >
                    View QR Code
                  </button>
                </div>
              </div>
              <div className="contact-info-item">
                <i className="fas fa-envelope contact-icon"></i>
                <div className="contact-info-content">
                  <span className="contact-label">Email</span>
                  <a href={`mailto:${email}`} className="contact-value contact-link">
                    {email}
                  </a>
                </div>
              </div>
              <div className="contact-info-item">
                <i className="fas fa-phone contact-icon"></i>
                <div className="contact-info-content">
                  <span className="contact-label">Phone</span>
                  <a href={`tel:${phone.replace(/\D/g, '')}`} className="contact-value contact-link">
                    {phone}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showQR && (
        <div className="qr-modal-overlay" onClick={() => setShowQR(false)}>
          <div className="qr-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="qr-modal-close" onClick={() => setShowQR(false)}>&times;</button>
            <h3>WeChat QR Code</h3>
            <img
              src={`${process.env.PUBLIC_URL}/wechat-qr.jpg`}
              alt="WeChat QR Code"
              className="qr-code-image"
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/300x300/f8f8f8/666666?text=Add+wechat-qr.png+to+public+folder';
              }}
            />
            <p className="qr-username">
              Scan to add:{' '}
              <span 
                className="qr-username-clickable"
                onClick={() => copyToClipboard(wechatUsername)}
                title="Click to copy"
              >
                {wechatUsername}
                {copied && <span className="copied-indicator"> ✓ Copied!</span>}
              </span>
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default ContactSection;
